import { GameState, UserAction } from '../api';
import { fightControlKind } from './fightPresentation';
import { isSkillCheckAcknowledgment, isSkillCheckProgression } from './SkillCheckActionControls';
import { isControllerAction, isUndoAction } from './UpkeepActions';

export type QuickAction = { action: UserAction; label: string; chooser: boolean; kind?: string };

/** Select presentation shortcuts without changing the registered actions or their IDs. */
export function quickActionPresentation(actions: UserAction[], viewer: string, state: GameState) {
  const seen = new Set<string>();
  const choices: QuickAction[] = [];
  for (const action of actions.filter(candidate => isControllerAction(candidate, viewer))) {
    const trade = action.trade;
    const chooser = action.sliderPosition != null || (!!trade && trade.direction !== 'finish');
    const key = action.sliderPosition != null ? `slider:${action.investigatorName}`
      : trade && trade.direction !== 'finish'
        ? JSON.stringify([trade.direction, trade.resource, trade.itemKey, trade.direction === 'take' ? trade.counterpartInvestigatorName : null])
        : action.id;
    if (seen.has(key)) continue;
    seen.add(key);
    const kind = fightControlKind(action, state.currentFightingMonster);
    const label = action.sliderPosition != null ? 'Adjust skills'
      : trade && trade.direction !== 'finish'
        ? `${trade.direction === 'give' ? 'Give' : 'Take'} ${trade.resource === 'money' ? 'money' : trade.resource === 'clue' ? 'clues' : (action.card as { name?: string } | null)?.name || 'item'}`
        : isSkillCheckAcknowledgment(action) ? 'OK' : action.name || action.description;
    choices.push({ action, label: label.trim(), chooser, kind });
  }
  const priority = (choice: QuickAction) => isSkillCheckAcknowledgment(choice.action) || isSkillCheckProgression(choice.action) ? 0
    : choice.kind === 'fight' ? 1 : choice.kind === 'evade' ? 2
      : state.currentPhase === 'Upkeep' && choice.action.id === 'end_upkeep' ? 1
        : state.currentPhase === 'Upkeep' && isUndoAction(choice.action) ? 2 : 3;
  const selected = [...choices].sort((a, b) => priority(a) - priority(b)).slice(0, 2);
  return { selected, hasMore: choices.length > selected.length };
}
